import { twApi } from '../api';
import {
  CommodityTableAttributes,
  CommodityCreationAttributes,
  CommodityUpdateAttributes,
  SearchCommoditiesParams,
  SearchCommoditiesResponseDto
} from './commodities.model';

const commoditiesApi = twApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCommodities: builder.query<CommodityTableAttributes[], void>({
      query: () => ({
        url: '/commodities',
        method: 'GET'
      }),
      providesTags: (result) => (result ? [{ type: 'Commodities', id: 'COMMODITIES_LIST' }] : [])
    }),
    getCommodityById: builder.query<CommodityTableAttributes, string>({
      query: (commodityId) => ({
        url: `/commodities/${commodityId}`,
        method: 'GET'
      }),
      providesTags: (result) => (result ? [{ type: 'Commodities', id: result.id }] : [])
    }),

    searchCommodities: builder.query<
      {
        content: SearchCommoditiesResponseDto[];
        more_records: boolean;
        total: number;
      },
      SearchCommoditiesParams
    >({
      query: (arg) => ({
        url: '/commodities/search',
        method: 'POST',
        body: {
          filters: arg.filters,
          params: arg.params
        }
      }),
      transformResponse: (response: {
        data: SearchCommoditiesResponseDto[];
        more_records: boolean;
        total: number;
      }) => ({
        content: response.data,
        more_records: response.more_records,
        total: response.total
      }),
      providesTags: (result) =>
        result?.content
          ? [
              ...result.content.map(({ id }) => ({ type: 'Commodities' as const, id })),
              { type: 'Commodities', id: 'COMMODITIES_LIST' }
            ]
          : [{ type: 'Commodities', id: 'COMMODITIES_LIST' }]
    }),

    createCommodity: builder.mutation<CommodityTableAttributes, CommodityCreationAttributes>({
      query: (body) => ({
        url: '/commodities',
        method: 'POST',
        body
      }),
      invalidatesTags: [{ type: 'Commodities', id: 'COMMODITIES_LIST' }]
    }),

    updateCommodity: builder.mutation<CommodityTableAttributes, { id: string; body: CommodityUpdateAttributes }>({
      query: ({ id, body }) => ({
        url: `/commodities/${id}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Commodities', id },
        { type: 'Commodities', id: 'COMMODITIES_LIST' }
      ]
    }),

    deleteCommodity: builder.mutation<void, string>({
      query: (commodityId) => ({
        url: `/commodities/${commodityId}`,
        method: 'DELETE'
      }),
      invalidatesTags: [{ type: 'Commodities', id: 'COMMODITIES_LIST' }]
    })
  })
});

export const {
  useGetAllCommoditiesQuery,
  useGetCommodityByIdQuery,
  useSearchCommoditiesQuery,
  useCreateCommodityMutation,
  useUpdateCommodityMutation,
  useDeleteCommodityMutation
} = commoditiesApi; 